angular.module('components.caPricelistGrid', [])
    .component('caPricelistGrid', {
        templateUrl: 'main/product/pricelisteditor/components/pricelistsgrid.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            articleCollectionId: '<',
            articleIds: '<',
            saleschannelId: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, $q, PricelistsApiService, ToasterService, loadSpinnerService, PricelistsHelperService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    vm.editorArticles = [];
    vm.priceListHeads = [];
    vm.useVariantDetail1Level = true;
    vm.useVariantDetail2Level = false;
    vm.volumeDiscounts = [];
    vm.showVolumeDiscountRules = false;
    vm.currentPage = 1;
    vm.itemsPerPage = 20;
    vm.itemsPerPageAlternatives = [
        20, 50, 100, 150
    ];

    vm.priceListPriceDisplaySelections = [
        { type: 'salesPrice', order: 1, label: 'article.salesprice' },
        { type: 'previousPrice', order: 2, label: 'article.previousprice'}
    ];
    vm.priceListPriceDisplaySelection = vm.priceListPriceDisplaySelections[0];

    //Methods
    vm.priceListSort = priceListSort;
    vm.save = save;
    vm.handlePriceChange = handlePriceChange;

    function onInit() {
        $scope.$watch(function() { return vm.articleIds; }, function() {
            if (vm.articleIds && vm.articleIds.length > 0) {
                loadArticles();
            } else {
                clearArticles();
            }
        });

        $scope.$watch(function() { return vm.useVariantDetail1Level; }, function(newValue, oldValue) {
            if (newValue !== undefined && newValue === false) {
                vm.showSku = false;
                vm.showBarcode = false;
            }
        });
        $scope.$watch(function() { return vm.useVariantDetail2Level; }, function(newValue, oldValue) {
            if (newValue !== undefined && newValue === false) {
                vm.showSku = false;
                vm.showBarcode = false;
            }
        });

        $scope.$watch(function() { return vm.useVariantDetail1Level; }, function() {
            loadArticles();
        });

        $scope.$watch(function() { return vm.useVariantDetail2Level; }, function() {
            loadArticles();
        });

        $scope.$watch(function() { return vm.saleschannelId; }, function() {
            loadArticles();
        });

        $scope.$watch(function() { return vm.articleCollectionId; }, function() {
            loadArticles();
        });

        $scope.$watch(function() { return vm.currentPage; }, function() {
            loadArticles();
        });
        $scope.$watch(function() { return vm.itemsPerPage; }, function() {
            loadArticles();
        });

        return PricelistsApiService.getVolumeDiscounts().then(function(response) {
            vm.volumeDiscounts = [];
            vm.volumeDiscounts.push({
                id: 0,
                name: '-'
            });
            _.forEach(response, function(volumeDiscount) {
                vm.volumeDiscounts.push(volumeDiscount);
            });
        }, function(error) {
            ToasterService.showError(error.message);
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function priceListSort(element) {
        if (element.id !== undefined) { // Element is a priceList
            return element.id;
        } else if (element.priceListId !== undefined) { //Element is a priceListItem
            return element.priceListId;
        } else {
            throw 'Unknown element to sort by';
        }
    }

    function save() {
        loadSpinnerService.start('mainSpinner');
        PricelistsApiService.savePriceListEditorArticles(vm.editorArticles).then(function(response) {
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function handlePriceChange(priceListItem, editorArticle) {
        var priceRangeToUpdate = _.find(editorArticle.priceListPrices, function(priceListPrice) {
            return priceListItem.priceListId === priceListPrice.priceListId;
        });

        var keys = Object.keys(priceListItem);
        _.remove(keys, function(fieldName) {
            return fieldName === "$$hashKey" || fieldName === "trackById";
        });

        _.forEach(keys, function(key) {
            priceRangeToUpdate[key] = priceListItem[key];
        });

        if(priceListItem.isCalculatedPrice){
            var priceList = _.find(vm.priceListHeads, function(priceListHead){
                return priceListHead.id === priceListItem.priceListId;
            });
            var exchangeRate = (priceList.exchangeRate !== 0) ? priceList.exchangeRate : 1;
            priceListItem.minPrice = (priceListItem.originalPriceMin * priceList.priceFactor) * exchangeRate;
            priceListItem.maxPrice = (priceListItem.originalPriceMax * priceList.priceFactor) * exchangeRate;
        }

        if (priceListItem.isSystemPrice) {
            PricelistsHelperService.recalculateRowPrices(priceListItem, editorArticle, vm.priceListHeads);
        }
    }

    function loadArticles() {
        if (vm.articleIds.length === 0 && vm.editorArticles.length === 0) {
            return;
        }

        vm.editorArticles = [];
        vm.priceListHeads = [];

        var request = {
            articleCollectionId: vm.articleCollectionId,
            articleIds: vm.articleIds,
            useVariantDetail1Level: vm.useVariantDetail1Level,
            useVariantDetail2Level: vm.useVariantDetail2Level,
            saleschannelId: vm.saleschannelId,
            page: vm.currentPage,
            pageSize: vm.itemsPerPage
        };

        loadSpinnerService.start('mainSpinner');
        PricelistsApiService.getPriceListEditorArticles(request).then(function(response) {
            vm.editorArticles = response.data.articles.results;
            vm.itemsPerPage = response.data.articles.limit;
            vm.currentPage = response.data.articles.page;
            vm.editorArticlesTotal = response.data.articles.total;

            vm.priceListHeads = response.data.priceLists;
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function clearArticles() {
        vm.editorArticles = [];
        vm.priceListHeads = [];
    }
}
